module.exports = __webpack_public_path__ + "img/circle-sort-down.2bfaf149.svg";